import { useEffect } from 'react';
import { PreviewIframeMessage, previewMessageBusSubject, createPreviewMessageEventHandler } from '@shared/utils/previewMessageBus';
import { isInIframe } from '@shared/utils/isInIframe';
import globalWindow from '@shared/core/globals';

const useWebsiteHeaderUpdatesListener = (refetch: () => void) => {
  const isPreviewing = isInIframe();

  useEffect(() => {
    if (!isPreviewing) {
      return;
    }

    const processMessage = (message: PreviewIframeMessage) => {
      switch (message.action) {
        case 'fromList':
          const shouldRefetch = message.value.some(value => value.key === 'eventDisplayName' || value.key === 'greetings');
          if (shouldRefetch) {
            refetch();
          }
          break;
        default:
          break;
      }
    };

    const previewSub = previewMessageBusSubject.subscribe({
      next: action => {
        if (action.type === 'sendMessage') {
          processMessage(action.payload.message);
        }
      }
    });

    const receiveMessage = createPreviewMessageEventHandler(processMessage);
    globalWindow.addEventListener?.('message', receiveMessage, false);

    return () => {
      previewSub?.unsubscribe();
      globalWindow.removeEventListener?.('message', receiveMessage, false);
    };
  }, [isPreviewing, refetch]);

  return null;
};

export default useWebsiteHeaderUpdatesListener;
